import script from "./CxSurfaceFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxSurfaceFilters.vue?vue&type=script&setup=true&lang=ts"

import "./CxSurfaceFilters.vue?vue&type=style&index=0&id=22a3f8d9&lang=less"

const __exports__ = script;

export default __exports__